import axios from 'axios'

const state = {
  sidebar: {
    opened: false,
  },
  config: {
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
  user: null,
  SourcesSites: [],
  PaymentsMethods: [],
  OrderStatuses: [],
}

const mutations = {
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  SET_USER_DATA (state, userData) {
    state.user = userData
    localStorage.setItem('user', JSON.stringify(userData))
    axios.defaults.headers.common.Authorization = `Bearer ${userData.access}`
  },
  CLEAR_USER_DATA () {
    const userString = localStorage.getItem('user')
    if (userString) {
      localStorage.removeItem('user')
      location.reload()
    }
  },
  setSourcesSites (state, data) {
    state.SourcesSites = data.reverse()
  },
  setPaymentsMethods (state, data) {
    state.PaymentsMethods = data.reverse()
  },
  setOrderStatuses (state, data) {
    state.OrderStatuses = data.reverse()
  },
}

const actions = {
  register ({ commit }, credentials) {
    return axios
      .post(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/register`,
        credentials,
      )
      .then(({ data }) => {
        commit('SET_USER_DATA', data)
      })
  },
  login ({ commit }, credentials) {
    return axios
      .post(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/auth/jwt/create/`,
        credentials,
      )
      .then(({ data }) => {
        data.username = credentials.username
        commit('SET_USER_DATA', data)
      })
  },
  refreshLogin ({ commit }, credentials) {
    return axios
      .post(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/auth/jwt/refresh/`, {
        refresh: credentials.refresh,
      })
      .then(({ data }) => {
        if (data.access) {
          credentials.access = data.access
          commit('SET_USER_DATA', credentials)
          location.reload()
        } else {
          commit('CLEAR_USER_DATA')
        }
      })
      .catch(() => {
        commit('CLEAR_USER_DATA')
      })
  },
  logout ({ commit }) {
    commit('CLEAR_USER_DATA')
  },
  getOrderStatuses ({ commit }) {
    return axios
      .options(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/orders/`)
      .then(({ data }) => {
        const statusChoices = data.actions.POST.status.choices.map(status => status.display_name)
        commit('setOrderStatuses', statusChoices)
      })
  },
  getSourcesSites ({ commit }) {
    return axios
      .get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/source-sites/`)
      .then(({ data }) => {
        commit('setSourcesSites', data)
      })
  },
  addSourceSite ({ dispatch }, credentials) {
    return axios
      .post(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/source-sites/`,
        credentials,
      )
      .then(() => {
        dispatch('getSourcesSites')
      })
      .catch(e => {
        console.log(e)
      })
  },
  updateSourceSite ({ dispatch }, credentials) {
    return axios
      .put(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/source-sites/${credentials.id}/`,
        credentials,
      )
      .then(() => {
        dispatch('getSourcesSites')
      })
      .catch(e => {
        console.log(e)
      })
  },
  deleteSourceSite ({ dispatch }, credentials) {
    return axios
      .delete(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/source-sites/${credentials}/`,
        credentials,
      )
      .then(() => {
        dispatch('getSourcesSites')
      })
      .catch(e => {
        console.log(e)
      })
  },
  getPaymentsMethods ({ commit }) {
    return axios
      .get(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/payment-methods/`,
      )
      .then(({ data }) => {
        commit('setPaymentsMethods', data)
      })
  },
  addPaymentMethod ({ dispatch }, credentials) {
    return axios
      .post(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/payment-methods/`,
        credentials,
      )
      .then(() => {
        dispatch('getPaymentsMethods')
      })
      .catch(e => {
        console.log(e)
      })
  },
  updatePaymentMethod ({ dispatch }, credentials) {
    return axios
      .put(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/payment-methods/${credentials.id}/`,
        credentials,
      )
      .then(() => {
        dispatch('getPaymentsMethods')
      })
      .catch(e => {
        console.log(e)
      })
  },
  deletePaymentMethod ({ dispatch }, credentials) {
    return axios
      .delete(
        `${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/payment-methods/${credentials}/`,
        credentials,
      )
      .then(() => {
        dispatch('getPaymentsMethods')
      })
      .catch(e => {
        console.log(e)
      })
  },
}

export default {
  state,
  mutations,
  actions,
}
